import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
	[_ in K]?: never;
};
export type Incremental<T> =
	| T
	| { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
};

/** The action failed due to an unexpected reason. */
export type ActionFailed = {
	__typename?: 'ActionFailed';
	/** Translated friendly message. */
	message: Scalars['String']['output'];
};

export type ContactInformation = {
	__typename?: 'ContactInformation';
	email: Scalars['String']['output'];
	isEmailVerified: Scalars['Boolean']['output'];
};

export type EmailAlreadyVerified = {
	__typename?: 'EmailAlreadyVerified';
	message: Scalars['String']['output'];
};

export type EmailVerificationError = ActionFailed | EmailAlreadyVerified | InvalidAction;

/** The action was not allowed for a given reason. */
export type InvalidAction = {
	__typename?: 'InvalidAction';
	/** Translated friendly message. */
	message: Scalars['String']['output'];
};

export type RequestEmailVerificationPayload = {
	__typename?: 'RequestEmailVerificationPayload';
	mutationErrors: Array<Maybe<EmailVerificationError>>;
	successful: Scalars['Boolean']['output'];
};

export type RootMutationType = {
	__typename?: 'RootMutationType';
	requestEmailVerification?: Maybe<RequestEmailVerificationPayload>;
	verifyEmail?: Maybe<VerifyEmailPayload>;
};

export type RootQueryType = {
	__typename?: 'RootQueryType';
	myContactInformation?: Maybe<ContactInformation>;
};

export type VerifyEmailPayload = {
	__typename?: 'VerifyEmailPayload';
	mutationErrors: Array<Maybe<EmailVerificationError>>;
	successful: Scalars['Boolean']['output'];
};

export type RequestEmailVerificationMutationVariables = Exact<{ [key: string]: never }>;

export type RequestEmailVerificationMutation = {
	__typename?: 'RootMutationType';
	requestEmailVerification?: {
		__typename?: 'RequestEmailVerificationPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'EmailAlreadyVerified'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| null
		>;
	} | null;
};

export type VerifyEmailMutationVariables = Exact<{ [key: string]: never }>;

export type VerifyEmailMutation = {
	__typename?: 'RootMutationType';
	verifyEmail?: {
		__typename?: 'VerifyEmailPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'EmailAlreadyVerified'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| null
		>;
	} | null;
};

export type ContactInformationQueryVariables = Exact<{ [key: string]: never }>;

export type ContactInformationQuery = {
	__typename?: 'RootQueryType';
	myContactInformation?: {
		__typename?: 'ContactInformation';
		email: string;
		isEmailVerified: boolean;
	} | null;
};

export const RequestEmailVerificationDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'RequestEmailVerification' },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'requestEmailVerification' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'EmailAlreadyVerified' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type RequestEmailVerificationMutationFn = Apollo.MutationFunction<
	RequestEmailVerificationMutation,
	RequestEmailVerificationMutationVariables
>;

/**
 * __useRequestEmailVerificationMutation__
 *
 * To run a mutation, you first call `useRequestEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEmailVerificationMutation, { data, loading, error }] = useRequestEmailVerificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestEmailVerificationMutation(
	baseOptions?: Apollo.MutationHookOptions<
		RequestEmailVerificationMutation,
		RequestEmailVerificationMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		RequestEmailVerificationMutation,
		RequestEmailVerificationMutationVariables
	>(RequestEmailVerificationDocument, options);
}
export type RequestEmailVerificationMutationHookResult = ReturnType<
	typeof useRequestEmailVerificationMutation
>;
export type RequestEmailVerificationMutationResult =
	Apollo.MutationResult<RequestEmailVerificationMutation>;
export type RequestEmailVerificationMutationOptions = Apollo.BaseMutationOptions<
	RequestEmailVerificationMutation,
	RequestEmailVerificationMutationVariables
>;
export const VerifyEmailDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'VerifyEmail' },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'verifyEmail' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'EmailAlreadyVerified' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type VerifyEmailMutationFn = Apollo.MutationFunction<
	VerifyEmailMutation,
	VerifyEmailMutationVariables
>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useVerifyEmailMutation(
	baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(
		VerifyEmailDocument,
		options
	);
}
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<
	VerifyEmailMutation,
	VerifyEmailMutationVariables
>;
export const ContactInformationDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'ContactInformation' },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'myContactInformation' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
								{ kind: 'Field', name: { kind: 'Name', value: 'isEmailVerified' } }
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useContactInformationQuery__
 *
 * To run a query within a React component, call `useContactInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactInformationQuery(
	baseOptions?: Apollo.QueryHookOptions<ContactInformationQuery, ContactInformationQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ContactInformationQuery, ContactInformationQueryVariables>(
		ContactInformationDocument,
		options
	);
}
export function useContactInformationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ContactInformationQuery,
		ContactInformationQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ContactInformationQuery, ContactInformationQueryVariables>(
		ContactInformationDocument,
		options
	);
}
export function useContactInformationSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<ContactInformationQuery, ContactInformationQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ContactInformationQuery, ContactInformationQueryVariables>(
		ContactInformationDocument,
		options
	);
}
export type ContactInformationQueryHookResult = ReturnType<typeof useContactInformationQuery>;
export type ContactInformationLazyQueryHookResult = ReturnType<
	typeof useContactInformationLazyQuery
>;
export type ContactInformationSuspenseQueryHookResult = ReturnType<
	typeof useContactInformationSuspenseQuery
>;
export type ContactInformationQueryResult = Apollo.QueryResult<
	ContactInformationQuery,
	ContactInformationQueryVariables
>;
export function refetchContactInformationQuery(variables?: ContactInformationQueryVariables) {
	return { query: ContactInformationDocument, variables: variables };
}
